// @ts-nocheck

import Api from '@/repository/api';
import { ISourcesRepository } from '@/repository/sources/SourcesRepository.types';
import { SourcesResponseType, ISources, ISourcesCreate } from '@/entity/sources/sources.types';
import Sources from '@/entity/sources/sources';
import { ResponseDataType } from '@/form/form.types';
import store from '@/store';
import {getStudioId} from '@/UI/lib/state';

export default class SourcesRepository implements ISourcesRepository {
    async fetchAll(salonId?: number): Promise<ISources[]> {
        const response = await Api.get('/clients/source/get', {params: {'filter[with_clients]': 1, 'filter[salon_id]': (typeof salonId === 'number' && salonId > 0 ? salonId : getStudioId({$store: store})) || undefined, limit: -1}});
        const respData = response.data.data as SourcesResponseType[];
        return respData.map((role: SourcesResponseType) => new Sources(role));
    }
    async delete(id): Promise<ISources[]> {
        const response = await Api.post(`/clients/source/delete?id=${id}`);
        return response;
    }
    async create(data: ISourcesCreate): Promise<ResponseDataType> {
        const response = await Api.post('/clients/source/create', {...data, salon_id: data.salon_id || getStudioId({$store: store})})
        return response.data
    }
    async update(data: any): Promise<ResponseDataType> {
        const response = await Api.post('/clients/source/update', data)
        return response.data
    }

}
